export function isMarkdown(maybeMarkdown: string | null | undefined) {
  if (!maybeMarkdown) {
    return false;
  }

  const regex =
    /(^#{1,6}\s)|(\*\*[^*]+\*\*)|(__[^_]+__)|(\*[^*]+\*)|(_[^_]+_)|(-\s.+)|(\*\s.+)|(\d+\.\s.+)|(\s{2,}\n)/;
  return regex.test(maybeMarkdown);
}
